// Haircare reviews
export const featuredReview1Haircare = {
  displayName: 'Kathy S.',
  date: '03/15/24',
  ratings: [
    [5, 'Shampoo'],
    [5, 'Conditioner'],
    [5, 'Scalp Mask'],
    [5, 'Hair Mask'],
  ],
  text: `This is amazing. I really tried everything else, every professional brand, and spent $100’s per bottle, but Prose is REAL ingredients and absolutely no damage. My hair is smooth, with no frizz, and it’s way beyond any hydration I’ve ever gotten from any other shampoo. I’m speechless right now. I’m just mad at myself that I didn’t try this sooner and wasted so much money on different brands. Prose, you saved my hair, my confidence has been through the roof. I can’t thank you enough!!`,
};
export const featuredReview2Haircare = {
  displayName: 'Kate P.',
  date: '03/06/24',
  ratings: [
    [5, 'Shampoo'],
    [5, 'Conditioner'],
    [3, 'Hair Mask'],
  ],
  text: `I love Prose so much. I've loved it through years of normal life. I've loved it through a year of IVF hormone treatments making my skin and hair do all kinds of wild things. And I'm loving it through pregnancy. Even when it doesn't work for a time because my ingredients change, the ability to give feedback and get a tweaked recipe has been enormous. And, the knowledge that what I'm putting on my body is safe for me (and baby!) through this whole process has been enormous. Prose makes it possible for me to let haircare be something I just don't think about that much and I love that.`,
};
export const featuredReview3Haircare = {
  displayName: 'Eileen M.',
  date: '04/27/24',
  ratings: [
    [4, 'Shampoo'],
    [5, 'Conditioner'],
    [5, 'Hair mask'],
  ],
  text: `I absolutely love the hair care. I have been using it for 2-3 years now. My hair is growing like crazy and I have a ton of new growth and I only have to get my hair trimmed twice a year. My hair stylist is always asking what I am doing to my hair because it is always soft and healthy. I always say that I use Prose.`,
};
export const featuredReview4Haircare = {
  displayName: 'Taylor P.',
  date: '04/02/24',
  ratings: [
    [5, 'Shampoo'],
    [5, 'Scalp Mask'],
    [1, 'Curl Cream'],
  ],
  text: `So happy I found Prose. After struggling with scalp issues for years, my scalp & hair finally feel clean, nourished, and healthy. I can honestly say that with Prose, the results are better than any brand I've tried before - and I've tried hundreds: big, small, natural, etc. 10/10 recommend!`,
};
export const featuredReview5Haircare = {
  displayName: 'Ariel E.',
  date: '05/03/24',
  ratings: [
    [5, 'Shampoo'],
    [5, 'Conditioner'],
    [3, 'Hair Mask'],
    [5, 'Curl Cream'],
  ],

  text: (
    <>
      So happy I found Prose. After struggling with scalp issues for years, my scalp & hair finally
      feel clean, nourished, and healthy. I can honestly say that with Prose, the results are better
      than any brand I’ve tried before - Growing up as one of the only kids with curly
      /semi-textured hair I always ALWAYS straightened my hair because my curls were just so frizzy
      and messy. Now as an adult, I’ve been trying to find ways to heal my inner child and let the
      curls be free, but they always just looked a mess. I saw adds for Prose and thought I’d give
      it a go. I really wanted to embrace and love my natural hair and had to at least try it. Even
      after using the products ONCE I saw a MASSIVE improvement. And now my curls are GLORIOUS and
      my inner child is so so happy! Prose really helped me heal some serious trauma and negative
      self image. Now I never want to straighten my hair because my curls are literally THRIVING! I
      can’t speak for straight-haired folk, but if you have curls you NEED to try this. I’m not even
      one who likes to tell ppl to sign up for expensive subscriptions but Prose is WORTH IT.
      <br />
      <br />
      My ONLY complaint is that the almond smell of the hair oil is a bit wonky. And it would be
      nice to have a sample of each smell sent out, so that one could smell them before committing
      to having them made into products.and I’ve tried hundreds: big, small, natural, etc. 10/10
      recommend!
    </>
  ),
};
export const featuredReview6Haircare = {
  displayName: 'Anne D.',
  date: '05/26/24',
  ratings: [
    [5, 'Shampoo'],
    [5, 'Conditioner'],
  ],
  text: `I have a lot of scalp problems, and a very terrible allergy to citrus peel, as well as parabens and blue dye. I kept trying shampoo after shampoo, but I kept reacting to every shampoo I tried, which resulted in worse scalp issues. The subpar "natural" shampoos I was using were making my hair look dull and crispy. My friend recommended Prose, and I gave it a shot despite the fairly high price tag. I could not be happier. Not only was I finally able to find a shampoo and conditioner that I was not reacting to, but the personalized products have helped my scalp and returned life and shine to my hair. Random strangers come up to me on the street to complement my hair now.`,
};
export const featuredReview7Haircare = {
  displayName: 'Christina G.',
  date: '03/04/24',
  ratings: [
    [5, 'Shampoo'],
    [5, 'Conditioner'],
    [5, 'Hair Mask'],
  ],
  text: `I have grey hair that has a tendency to dry out and be unruly, but since I started using Prose, my hair is softer and more manageable that it has been in quite a while. I love the fragrance.`,
};

// Skincare reviews
export const featuredReview1Skincare = {
  displayName: 'Sandra D.',
  date: '03/17/24',
  ratings: [
    [5, 'Cleanser'],
    [5, 'Serum'],
    [5, 'Moisturizer'],
  ],
  text: `I am currently being treated for cancer, which made my already sensitive skin even more so, as well as drying it out. I have eczema and my treatment causes a red acne rash. Prose has worked even better than my expensive skin care products and actually improved hydration and skin redness.`,
};
export const featuredReview2Skincare = {
  displayName: 'Kelly Y.',
  date: '03/14/24',
  ratings: [
    [5, 'Cleanser'],
    [5, 'Serum'],
    [5, 'Moisturizer'],
  ],
  text: `I have to say, I was skeptical about Prose moving into the skincare space. I love the haircare but wasn't sure what the skincare would be like...8 months later, I can truly say that I love my Prose skincare! I've been using the entire system consistently and my skin has definitely become more smooth, hydrated and radiant. I notice less texture on my cheeks, fainter lines in my forehead, and overall my skin just looks bouncier and more hydrated. The products feel so luxe and I love the packaging. The serum and moisturizer sink into my skin like a dream. They are so lightweight! The cleanser is my favorite though - it foams beautifully without leaving my skin squeaky or stripped. Thanks for proving me wrong, Prose! I'm excited to keep up with it and refine my formulas for even more improvement.`,
};
export const featuredReview3Skincare = {
  displayName: 'Monique M.',
  date: '04/06/24',
  ratings: [
    [5, 'Cleanser'],
    [5, 'Moisturizer'],
  ],
  text: `So far the skin care has been game changing. I have struggled so much with my skin being weirdly in between oily but acne prone, and dry and red, with past products addressing one thing but making another worse (I.e moisturizing but causes breakouts) but prose checks all the boxes.`,
};
export const featuredReview4Skincare = {
  displayName: 'Brandy C.',
  date: '05/22/24',
  ratings: [
    [5, 'Cleanser'],
    [4, 'Serum'],
    [5, 'Moisturizer'],
  ],
  text: `I’m quite impressed with this skincare regimen. I was starting to have some issues that I thought were just part of aging but this formula has addressed a lot of it. It feels great, works great and smells great!`,
};
export const featuredReview5Skincare = {
  displayName: 'Sandy G.',
  date: '05/22/24',
  ratings: [
    [5, 'Cleanser'],
    [5, 'Serum'],
    [5, 'Moisturizer'],
  ],
  text: `Overall I am super happy with Prose. It’s very important to me that everything is environmentally sustainable. I love that the product ingredients are natural and without parabens, sulfates and silicones. Natural and sustainable is the new way! 💛`,
};
export const featuredReview6Skincare = {
  displayName: 'Marcus M.',
  date: '05/18/24',
  ratings: [
    [5, 'Cleanser'],
    [5, 'Serum'],
    [5, 'Moisturizer'],
  ],
  text: `So far I love my Prose skin care products! I enjoy the personalization and the attention the Prose team takes in finding out when a product is or is not working as I would like it to, and then making adjustments for my skin’s unique needs. I brag about this company and the products every chance I get to just about anyone who will listen. I used to not put too much effort in my face care, and now that I do, I will never go back to over-the-counter soaps and moisturizers. Prose has really changed the game for me!`,
};
export const featuredReview7Skincare = {
  displayName: 'Kasia K.',
  date: '03/20/24',
  ratings: [
    [5, 'Cleanser'],
    [5, 'Serum'],
    [4, 'Moisturizer'],
  ],
  text: `The skincare is absolutely worth a try!! I have been using the same routine for over 5 years and seen great results, so I was hesitant to try a different routine. The transition was seamless over to Prose and I was really impressed with the formulations for my skin. No brand has been able to get the moisturizing levels right for my skin, but Prose did in its first round and managed to keep things lightweight too! The cleanser and serum were absolute standouts. Magic in a bottle.`,
};

export const featuredReviews = [
  {
    title: 'haircare',
    reviews: [
      featuredReview1Haircare,
      featuredReview2Haircare,
      featuredReview3Haircare,
      featuredReview4Haircare,
      featuredReview5Haircare,
      featuredReview6Haircare,
      featuredReview7Haircare,
    ],
  },
  {
    title: 'skincare',
    reviews: [
      featuredReview1Skincare,
      featuredReview2Skincare,
      featuredReview3Skincare,
      featuredReview4Skincare,
      featuredReview5Skincare,
      featuredReview6Skincare,
      featuredReview7Skincare,
    ],
  },
];
